export default __webpack_public_path__ + "static/media/seal.5929f145.png";